module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp123_8011.cbad2b13.png";